var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"stepper",attrs:{"data-testid":"stepper"}},_vm._l((_vm.steps),function(step,index){return _c('div',{key:index,staticClass:"stepper__segment",class:{ 'stepper__segment--filled': step.filled }})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }